(function () {
  function stepSize(track) {
    var item = track.children[0];
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return (item ? item.getBoundingClientRect().width : track.clientWidth * 0.8) + gap;
  }
  function refresh(el) {
    var track = el.querySelector('.logo-carousel__track');
    if (!track) return;
    el.classList.toggle('logo-carousel--overflow', track.scrollWidth > track.clientWidth + 2);
    // Soft "at edge" state (for arrow dimming) — never disables the button, so clicks always work.
    var max = track.scrollWidth - track.clientWidth - 2;
    var prev = el.querySelector('[data-logo-prev]');
    var next = el.querySelector('[data-logo-next]');
    if (prev) prev.classList.toggle('logo-carousel__arrow--edge', track.scrollLeft <= 1);
    if (next) next.classList.toggle('logo-carousel__arrow--edge', track.scrollLeft >= max);
  }

  // Delegated button clicks — works regardless of when the section renders
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-logo-prev],[data-logo-next]');
    if (!btn) return;
    var el = btn.closest('.logo-carousel');
    var track = el && el.querySelector('.logo-carousel__track');
    if (!track) return;
    var dir = btn.hasAttribute('data-logo-next') ? 1 : -1;
    track.scrollBy({ left: dir * stepSize(track), behavior: 'smooth' });
  });

  // Update arrow state on scroll
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('logo-carousel__track')) {
      var el = t.closest('.logo-carousel');
      if (el) refresh(el);
    }
  }, true);

  function init(root) {
    (root || document).querySelectorAll('.logo-carousel').forEach(function (el) {
      var track = el.querySelector('.logo-carousel__track');
      if (!track) return;
      refresh(el);
      if (window.ResizeObserver && !el.__logoRO) {
        el.__logoRO = new ResizeObserver(function () { refresh(el); });
        el.__logoRO.observe(track);
      }
      if (el.hasAttribute('data-autoplay') && !el.__logoAuto) {
        el.__logoAuto = true;
        var speed = (parseFloat(el.getAttribute('data-autoplay-speed')) || 3) * 1000;
        var timer = null;
        function tick() {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
          else track.scrollBy({ left: stepSize(track), behavior: 'smooth' });
        }
        function start() { if (track.scrollWidth > track.clientWidth + 2) { stop(); timer = setInterval(tick, speed); } }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        el.addEventListener('pointerenter', stop);
        el.addEventListener('pointerleave', start);
        el.addEventListener('touchstart', stop, { passive: true });
        start();
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
